import logo from '../AdminLayout/assets/logo.svg'

const PublicHeader = () => {
  const webUrl = 'https://www.faceup.com'

  return (
    <div className='flex w-full shrink-0 justify-center'>
      <header className='m-8 flex w-full max-w-[1280px] items-center justify-between font-semibold text-colorTextTertiary uppercase'>
        <a href={webUrl}>
          <img src={logo} alt='Logo FaceUp' className='max-h-11 w-auto max-w-[170px]' />
        </a>
      </header>
    </div>
  )
}

export default PublicHeader
